import { render, staticRenderFns } from "./shoppingcart.vue?vue&type=template&id=1a3b4870&scoped=true&"
import script from "./shoppingcart.vue?vue&type=script&lang=js&"
export * from "./shoppingcart.vue?vue&type=script&lang=js&"
import style0 from "./shoppingcart.vue?vue&type=style&index=0&id=1a3b4870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b4870",
  null
  
)

export default component.exports